import { createReducer } from '@reduxjs/toolkit';
import { getDashboardSummary } from 'redux/actions/dashboard';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(getDashboardSummary.pending, (state) => {
      state.app.dashboardSummary.isSummaryLoading = true;
      state.app.dashboardSummary.summary = initialRootState.app.dashboardSummary.summary;
    })
    .addCase(getDashboardSummary.fulfilled, (state, action) => {
      state.app.dashboardSummary.isSummaryLoading = false;
      state.app.dashboardSummary.onceLoaded = true;
      state.app.dashboardSummary.summary = action.payload.result;
    })
    .addCase(getDashboardSummary.rejected, (state) => {
      state.app.dashboardSummary.isSummaryLoading = false;
    });
});
